import React from "react";
import styled from "styled-components";

export const Text = (props) => {
    return (
        <StyledInput type="text" {...props}></StyledInput>
    )
};

const StyledInput = styled.input`
	display: block;
	padding: 0 12px;
	width: 100%;
	background-color: white;
	border-radius: var(--borderRadius);
	border: 1px solid var(--border);
	line-height: var(--lineHeight);
	& + & {margin-top: 10px}
`;

export default Text;